export const selectMessage = ({ SharedSlice: oState }) => {
  return {
    message: oState?.sMessage,
    type: oState?.sMessageType,
  };
};

export const selectLoading = ({ SharedSlice: oState }) => oState?.bLoading;
